import { useEffect, useRef, useState } from "react";
import { Col, Overlay, Row, Tooltip } from "react-bootstrap";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Oven from "../../../images/oven_green.svg";
import Box from "../../../images/boxes.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import { useGetMoistureRoomLogsQuery } from "../rework/reworkApi";
import MoistureRoomModal from "../rework/MoistureRoomModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate, makePriorLotNumber } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import InfoCard from "../../../components/shared/infocard/InfoCard";
import NoDataFound from "../../../components/shared/noDataFound/NoDataFound";
import moment from "moment";
import { useGetToastedLogsQuery, useGetToastedSummaryQuery, useGetCheekStripPackedDataForReworkQuery, useProcessAccumulatedDataMutation } from "../rework/reworkApi";
import { useGetToastedSortingRecordQuery } from "./toastedApi";
import ToastedSortingModal from "./ToastedSortingModal";
import ToastedStatusModal from "./ToastedStatusModal";
import RewarkPackedDataModal from "../rework/RewarkPackedDataModal";

const initialFilters = { type: "all", status: "accumulated", entered_date: "" };

const Toasted = () => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date] = useState(currentDate);
  const [lotNumber, setLotNumber] = useState(makePriorLotNumber(currentDate));
  const [page, setPage] = useState(1);
  const [tablePage, setTablePage] = useState(1);
  const [activeBaggedTooltip, setActiveBaggedTooltip] = useState(null);
  const [isHoveringBaggedTooltip, setIsHoveringBaggedTooltip] = useState(false);
  const baggedTooltipRefs = useRef({});
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusForm, setStatusForm] = useState(null);
  const [showBoxModal, setShowBoxModal] = useState(false);
  const [selectedBox, setSelectedBox] = useState(null);
  const [tableFilters, setTableFilters] = useState(initialFilters);
  const [packingBoxTab, setPackingBoxTab] = useState("cheeks");
  const [addPackingData, setAddPackingData] = useState(false);
  const [packingModalMode, setPackingModalMode] = useState("");
  const [packingRecord, setPackingRecord] = useState(null);
  const [showPackingModal, setShowPackingModal] = useState(false);

  const reworkToastLogLimit = 5;
  const toastOvenLogLimit = 10;

  useEffect(() => { setLotNumber(makePriorLotNumber(date)); }, [date]);

  const { data: sortingRecordData } = useGetToastedSortingRecordQuery({ date });
  const { data: summaryResponse } = useGetToastedSummaryQuery({}, { refetchOnMountOrArgChange: true });

  const logsQueryParams = { page: tablePage, per_page: reworkToastLogLimit };
  if (tableFilters.type && tableFilters.type !== "all") logsQueryParams.type = tableFilters.type;
  if (tableFilters.status && tableFilters.status !== "all") logsQueryParams.status = tableFilters.status;
  if (tableFilters.entered_date) logsQueryParams.entered_date = tableFilters.entered_date;

  const { data: toastedReworkLogs, isLoading: isLogsLoading } = useGetToastedLogsQuery(
    logsQueryParams,
    { refetchOnMountOrArgChange: true }
  );

  const { data: moistureData, isLoading: isMoistureLoading, isFetching: isMoistureFetching } = useGetMoistureRoomLogsQuery({ date, page, per_page: toastOvenLogLimit }, { refetchOnMountOrArgChange: true });

  const { data: packedData } = useGetCheekStripPackedDataForReworkQuery(
    { date, data_source: "rework", data_type: "toasted" },
    { refetchOnMountOrArgChange: true }
  );
  const [processAccumulatedData, { isLoading: isProcessing }] = useProcessAccumulatedDataMutation();

  const isToday = date === currentDate;
  const cheeksRecord = packedData?.data?.data?.find((item) => item.type === "cheeks" && item?.id);
  const stripsRecord = packedData?.data?.data?.find((item) => item.type === "strips" && item?.id);
  const hasCheeksRecord = Boolean(cheeksRecord);
  const hasStripsRecord = Boolean(stripsRecord);

  const summaryData = summaryResponse?.data || {};
  // const logsPayload = logsResponse?.data || {};

  // const filteredToastedLogs = Array.isArray(logsPayload?.data) ? logsPayload.data : [];

  // const toastTableData = useMemo(() => ({
  //   data: filteredToastedLogs,
  //   pagination: { total: logsPayload?.pagination?.total || 0 },
  // }), [filteredToastedLogs, logsPayload?.pagination?.total]);

  const [cheeksBoxesPackedData, setCheeksBoxesPackedData] = useState([]);
  const [stripsBoxesPackedData, setStripsBoxesPackedData] = useState([]);

  useEffect(() => {
    const items = packedData?.data?.data;
    setCheeksBoxesPackedData(
      items?.filter((item) => item.type === "cheeks").map((item) => [
        { label: _t("prime_packed_before_lunch", "Prime Packed Before Lunch"), value: `${item.packed_before_lunch_type_one || 0}`, subvalue: _t("ten_pounds", "(10 pounds)") },
        { label: _t("prime_packed_after_lunch", "Prime Packed After Lunch"), value: `${item.packed_after_lunch_type_one || 0}`, subvalue: _t("ten_pounds", "(10 pounds)") },
        { label: _t("prime_packed_before_lunch", "Prime Packed Before Lunch"), value: `${item.packed_before_lunch_type_two || 0}`, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("prime_packed_after_lunch", "Prime Packed After Lunch"), value: `${item.packed_after_lunch_type_two || 0}`, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("seconds_boxes_before_lunch", "Seconds boxes Before Lunch"), value: item.second_before_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("seconds_boxes_after_lunch", "Seconds boxes After Lunch"), value: item.second_after_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("tapita_packed_before_lunch_20_pound", "Tapita packed before lunch"), value: item?.tapita_before_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("tapita_packed_after_lunch_20_pound", "Tapita packed after lunch"), value: item?.tapita_after_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("pieces_packed_before_lunch_20_pound", "Pieces packed before lunch"), value: item?.pieces_before_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("pieces_packed_after_lunch_20_pound", "Pieces packed after lunch"), value: item?.pieces_after_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("total_cheek_boxes_packed", "Total Cheek Boxes Packed"), value: item.boxes_packed },
        { label: _t("total_cheek_pallets_ready", "Total Cheek Pallets Ready"), value: item.pallets },
      ]) ?? []
    );
    setStripsBoxesPackedData(
      items?.filter((item) => item.type === "strips").map((item) => [
        { label: _t("prime_packed_before_lunch", "Prime Packed Before Lunch"), value: `${item.packed_before_lunch_type_two || 0}`, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("prime_packed_after_lunch", "Prime Packed After Lunch"), value: `${item.packed_after_lunch_type_two || 0}`, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("seconds_boxes_before_lunch", "Seconds boxes Before Lunch"), value: item.second_before_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("seconds_boxes_after_lunch", "Seconds boxes After Lunch"), value: item.second_after_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("pieces_packed_before_lunch_20_pound", "Pieces packed before lunch"), value: item?.pieces_before_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("pieces_packed_after_lunch_20_pound", "Pieces packed after lunch"), value: item?.pieces_after_lunch_type_two, subvalue: _t("twenty_pounds", "(20 pounds)") },
        { label: _t("total_strip_boxes_packed", "Total Strip Boxes Packed"), value: item.boxes_packed },
        { label: _t("total_strip_pallets_ready", "Total Strip Pallets Ready"), value: item.pallets },
      ]) ?? []
    );
  }, [packedData]);

  const listItems = [
    { label: _t("total_toasted_cheeks_kg", "Total Toasted Cheeks Kg"), value: summaryData?.total_kg_cheeks_in_toasted || 0, icon: Oven, showDay: false },
    { label: _t("total_toasted_strips_kg", "Total Toasted Strips Kg"), value: summaryData?.total_kg_strips_in_toasted || 0, icon: Oven, showDay: false },
    { label: _t("total_cheeks_kg_bagged", "Total Cheeks Kg Bagged"), value: summaryData?.total_cheeks_kg_bagged || 0, icon: Box, showDay: false },
    { label: _t("total_strips_kg_bagged", "Total Strips Kg Bagged"), value: summaryData?.total_strips_kg_bagged || 0, icon: Box, showDay: false },
    { label: _t("total_tapita_kg_bagged", "Total Tapita Kg Bagged"), value: summaryData?.total_tapita_kg_bagged || 0, icon: Box, showDay: false },
  ];

  const handleFilterApply = (newFilters) => { setTableFilters((prev) => ({ ...prev, ...newFilters })); setTablePage(1); };
  const handlePageChange = (newPage) => setPage(newPage);
  const handleOpenBoxModal = (box) => { setSelectedBox(box); setShowBoxModal(true); };
  const handleAddData = () => { setAddRecord(true); setModalMode("add"); setSelectedRecord(null); setShowModal(true); };
  const handleEdit = (data) => { setAddRecord(true); setModalMode("edit"); setSelectedRecord(data); setShowModal(true); };
  const handleProcessAll = async () => {
    try { await processAccumulatedData({ entity_type: "toasted" }).unwrap(); }
    catch (error) { console.error("Error processing accumulated data:", error); }
  };
  const handleCheeksPacked = () => {
    if (!isToday && hasCheeksRecord) return;
    setAddPackingData(true); setPackingModalMode(hasCheeksRecord ? "editCheeks" : "cheeks");
    setPackingRecord(hasCheeksRecord ? cheeksRecord : null); setShowPackingModal(true);
  };
  const handleStripsPacked = () => {
    if (!isToday && hasStripsRecord) return;
    setAddPackingData(true); setPackingModalMode(hasStripsRecord ? "editStrips" : "strips");
    setPackingRecord(hasStripsRecord ? stripsRecord : null); setShowPackingModal(true);
  };

  const toastedLogColumns = [
    { label: _t("humidity_table_date", "Date"), accessor: "created_at", cell: ({ value }) => convertToUserTimezone(value, "DD-MM-YYYY hh:mm A") },
    { 
      label: _t("lot_no", "Lot No."),
      accessor: "lot_number" ,
      cell: ({ value }) => value ? `#${value}` : "",
    },
    { label: _t("humidity_table_type", "Type"), accessor: "type", cell: ({ value }) => _t("type_" + value, value.charAt(0).toUpperCase() + value.slice(1)) },
    { label: _t("total_kg", "Total KG"), accessor: "total_kg" },
    {
      label: _t("status", "Status"), accessor: "status",
      cell: ({ row }) => (
        <span className={row.status === "processed" ? "cmn_badge" : "cmn_badge inactive"} style={{ cursor: "pointer" }}>
          {row.status === "processed" ? _t("processed", "Processed") : _t("accumulated", "Accumulated")}
        </span>
      ),
    },
  ];

  const moistureColumns = [
    { label: _t("table_date", "Date"), accessor: "created_at", cell: ({ row }) => convertToUserTimezone(row.created_at) },
    { label: _t("table_carts_number", "Carts Number"), accessor: "cart_number", cell: ({ row }) => row.cart_number?.name || "-" },
    { label: _t("table_type", "Type"), accessor: "type", cell: ({ row }) => _t("type_" + row.type, row.type.charAt(0).toUpperCase() + row.type.slice(1)) },
    { label: _t("table_treys_count", "Treys Count"), accessor: "treys_count" },
    {
      label: _t("table_status", "Status"), accessor: "status",
      cell: ({ row }) => (
        <span className={row.status === "cart_unloaded" ? "cmn_badge done" : "cmn_badge inactive"}>
          {row.status === "cart_unloaded" ? _t("status_cart_unloaded", "Cart Unloaded") : _t("status_hydrating", "Hydrating")}
        </span>
      ),
    },
    { label: _t("table_time_end", "Time End"), accessor: "time_end", cell: ({ value }) => moment(value).format("YYYY-MM-DD HH:mm") },
    {
      label: _t("bagged_weight", "Bagged Weight"), accessor: "status",
      cell: ({ row }) => {
        if (row.status !== "cart_unloaded") return <span style={{ color: "#ccc" }}>—</span>;
        const { type, cheeks_kg_bagged, strips_kg_bagged, tapita_kg_bagged } = row;
        const pairs =
          type === "cheeks" ? [[_t("cheeks", "Cheeks"), cheeks_kg_bagged]] :
          type === "strips" ? [[_t("strips", "Strips"), strips_kg_bagged]] :
          type === "tapita" ? [[_t("tapita", "Tapita"), tapita_kg_bagged]] :
          type === "cheeks/strips" ? [[_t("cheeks", "Cheeks"), cheeks_kg_bagged], [_t("strips", "Strips"), strips_kg_bagged]] :
          type === "cheeks/tapita" ? [[_t("cheeks", "Cheeks"), cheeks_kg_bagged], [_t("tapita", "Tapita"), tapita_kg_bagged]] : [];
        const total = pairs.reduce((sum, [, v]) => sum + (Number(v) || 0), 0);
        if (!baggedTooltipRefs.current[row.id]) baggedTooltipRefs.current[row.id] = { current: null };
        return (
          <span className="d-flex align-items-center gap-1">
            <span
              ref={(el) => { if (!baggedTooltipRefs.current[row.id]) baggedTooltipRefs.current[row.id] = { current: null }; baggedTooltipRefs.current[row.id].current = el; }}
              style={{ background: "rgba(238,114,37,0.08)", border: "1px solid rgba(238,114,37,0.25)", borderRadius: "6px", padding: "2px 10px", fontSize: "12px", color: "#ee7225", fontWeight: 600, cursor: "pointer" }}
              onMouseEnter={() => setActiveBaggedTooltip(row.id)}
              onMouseLeave={() => setTimeout(() => { if (!isHoveringBaggedTooltip) setActiveBaggedTooltip(null); }, 100)}
              onClick={() => setActiveBaggedTooltip(activeBaggedTooltip === row.id ? null : row.id)}
            >{total} kg</span>
            <Overlay target={baggedTooltipRefs.current[row.id]?.current} show={activeBaggedTooltip === row.id} placement="top" rootClose onHide={() => { if (!isHoveringBaggedTooltip) setActiveBaggedTooltip(null); }}>
              {(props) => (
                <Tooltip id={`bagged-tooltip-${row.id}`} {...props} className="custom-tooltip" onMouseEnter={() => setIsHoveringBaggedTooltip(true)} onMouseLeave={() => { setIsHoveringBaggedTooltip(false); setActiveBaggedTooltip(null); }}>
                  <div className="tooltip-content">
                    <div className="tooltip-header">{_t("bagged_weight_breakdown", "Bagged Weight")}</div>
                    <ul className="tooltip-list">{pairs.map(([label, value]) => (<li key={label}><span>• {label}</span><span className="tooltip-amount">{value ?? 0} kg</span></li>))}</ul>
                  </div>
                </Tooltip>
              )}
            </Overlay>
          </span>
        );
      },
    },
    {
      label: _t("table_overview", "Overview"), accessor: "id",
      cell: ({ row }) => row.status === "cart_unloaded" ? <span /> : (
        <Button size="small" label={_t("button_edit", "Edit")} onClick={() => handleEdit(row)} disabled={row.status === "cart_unloaded"} />
      ),
    },
  ];

  return (
    <div>
      {addRecord && (
        <MoistureRoomModal show={showModal} setShow={setAddRecord} mode={modalMode} record={selectedRecord} date={date} lot_number_id={lotNumber} />
      )}
      {showBoxModal && (
        <ToastedSortingModal show={showBoxModal} setShow={setShowBoxModal} record={selectedBox} mode={selectedBox ? "edit" : "add"} />
      )}
      {addPackingData && (
        <RewarkPackedDataModal show={showPackingModal} setShow={setAddPackingData} mode={packingModalMode} record={packingRecord} lot_number_id={lotNumber} data_source="rework" data_type="toasted" />
      )}
      {showStatusModal && (
        <ToastedStatusModal show={showStatusModal} setShow={setShowStatusModal} statusForm={statusForm} setStatusForm={setStatusForm} />
      )}

      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("toasted_overview_title", "Toasted Overview")}</h6>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard key={index} title={list.label} value={list.value} icon={list.icon} day={currentDate === date ? _t("common_today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)} showDay={list.showDay} />
          ))}
        </ul>
      </div>
{/* {
console.log(toastedReworkLogs)} */}
      {/* Rework Logs */}
      <div className="my-3" />
      <div className="humid_logs h-100 pt-2">
        <Datatable
          title={_t("toasted_rework_logs", "Toasted Rework Logs")}
          columns={toastedLogColumns}
          tableData={toastedReworkLogs?.data}
          showPegination={true}
          page={tablePage}
          onPageChange={setTablePage}
          showCount={true}
          showFilter={handleFilterApply}
          showFilterButton={true}
          filterModule="toasted-logs-filter"
          filters={tableFilters}
          pageLimit={reworkToastLogLimit}
          isLoading={isLogsLoading}
          totalRecordsTitle={_t("number_of_toasted_logs", "Number of Toasted Logs")}
          buttons={[
            {
              label: isProcessing ? _t("processing", "Processing...") : _t("process_all_accumulated", "Process All Accumulated"),
              onClick: handleProcessAll,
            },
          ]}
        />
      </div>

      {/* Oven Logs */}
      <div className="my-3" />
      <div className="humid_logs h-100 pt-2">
        <Datatable
          title={_t("table_toasted_room_logs", "Toasted Room Logs")}
          columns={moistureColumns}
          tableData={moistureData?.data}
          buttons={[{ label: _t("button_add_toasted_data", "Add Toasted Data"), onClick: handleAddData, icon: PlusSvg }]}
          showPegination={true}
          page={page}
          pageLimit={toastOvenLogLimit}
          showCount={true}
          onPageChange={handlePageChange}
          isLoading={isMoistureLoading || isMoistureFetching}
        />
      </div>

      {/* Sorting & Packing Boxes */}
      <div className="my-3" />
      <Row className="g-3">
        <Col lg={6}>
          <div className="dash_card h-100">
            <div className="d-flex justify-content-between align-items-center dash_header">
              <h3 className="mb-0">{_t("cheeks_strips_sorting_data", "Cheeks/Strip Sorting Data")}</h3>
              <Button size="xs" label={sortingRecordData?.data?.id ? _t("edit_data", "Edit Data") : _t("add_data", "Add Data")} icon={PlusSvg} onClick={() => handleOpenBoxModal(sortingRecordData?.data?.id ? sortingRecordData.data : null)} />
            </div>
            <div className="p-3">
              <Row>
                {sortingRecordData?.data?.id ? (() => {
                  const box = sortingRecordData.data;
                  return (
                    <>
                      <Col lg={6}><InfoCard label={_t("prime_cheeks_kg", "Prime Cheeks Kg")} value={box.prime_cheeks_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("second_cheeks_kg", "Second Cheeks Kg")} value={box.second_cheeks_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("prime_strips_kg", "Prime Strips Kg")} value={box.prime_strips_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("second_strips_kg", "Second Strips Kg")} value={box.second_strips_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("tapita_kg", "Tapita Kg")} value={box.tapita_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("pieces_kg", "Pieces Kg")} value={box.pieces_kg} /></Col>
                      <Col lg={6}><InfoCard label={_t("trash", "Trash")} value={box.rejected_kg} /></Col>
                    </>
                  );
                })() : <NoDataFound />}
              </Row>
            </div>
          </div>
        </Col>

        {/* Packing Box */}
        <Col lg={6}>
          <div className="dash_card h-100">
            <div className="d-flex justify-content-between align-items-center dash_header">
              <h3 className="mb-0">{_t("rework_packing_box_logs", "Packing Logs")}</h3>
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex" style={{ background: "rgba(238,114,37,0.08)", borderRadius: "6px", padding: "2px" }}>
                  <button onClick={() => setPackingBoxTab("cheeks")} style={{ border: "none", borderRadius: "5px", padding: "3px 12px", fontSize: "12px", fontWeight: 600, cursor: "pointer", background: packingBoxTab === "cheeks" ? "#ee7225" : "transparent", color: packingBoxTab === "cheeks" ? "#fff" : "#ee7225", transition: "all 0.15s" }}>
                    {_t("type_cheeks", "Cheeks")}
                  </button>
                  <button onClick={() => setPackingBoxTab("strips")} style={{ border: "none", borderRadius: "5px", padding: "3px 12px", fontSize: "12px", fontWeight: 600, cursor: "pointer", background: packingBoxTab === "strips" ? "#ee7225" : "transparent", color: packingBoxTab === "strips" ? "#fff" : "#ee7225", transition: "all 0.15s" }}>
                    {_t("type_strips", "Strips")}
                  </button>
                </div>
                {packingBoxTab === "cheeks" ? (
                  (isToday || !hasCheeksRecord) && <Button size="xs" label={hasCheeksRecord ? _t("edit_data", "Edit Data") : _t("add_data", "Add Data")} icon={PlusSvg} onClick={handleCheeksPacked} />
                ) : (
                  (isToday || !hasStripsRecord) && <Button size="xs" label={hasStripsRecord ? _t("edit_data", "Edit Data") : _t("add_data", "Add Data")} icon={PlusSvg} onClick={handleStripsPacked} />
                )}
              </div>
            </div>
            <div className="p-3">
              {packingBoxTab === "cheeks" ? (
                <Row>
                  {cheeksBoxesPackedData?.length > 0 ? cheeksBoxesPackedData.map((data, index) => (
                    <Row key={index}>{data.map((item, i) => <Col lg={6} key={`${item.label}-${i}`}><InfoCard label={item.label} value={item.value} subvalue={item?.subvalue ?? ""} /></Col>)}</Row>
                  )) : <NoDataFound />}
                </Row>
              ) : (
                <Row>
                  {stripsBoxesPackedData?.length > 0 ? stripsBoxesPackedData.map((data, index) => (
                    <Row key={index}>{data.map((item, i) => <Col lg={6} key={`${item.label}-${i}`}><InfoCard label={item.label} value={item.value} subvalue={item?.subvalue ?? ""} /></Col>)}</Row>
                  )) : <NoDataFound />}
                </Row>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Toasted;
